// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountCreationPropertyDto
 */
export interface IAccountCreationPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IAccountCreationPropertyDto
     */
    account_creation_type?: IAccountCreationPropertyDtoAccountCreationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountCreationPropertyDto
     */
    account_creation_type_state?: IAccountCreationPropertyDtoAccountCreationTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountCreationPropertyDtoAccountCreationTypeEnum {
    REUSE_WHEN_SAME_ACCOUNT = 'REUSE_WHEN_SAME_ACCOUNT',
    CREATE_NEW = 'CREATE_NEW'
}
/**
* @export
* @enum {string}
*/
export enum IAccountCreationPropertyDtoAccountCreationTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAccountCreationPropertyDto interface.
 */
export function instanceOfIAccountCreationPropertyDto(value: object): value is IAccountCreationPropertyDto {
    return true;
}

export function IAccountCreationPropertyDtoFromJSON(json: any): IAccountCreationPropertyDto {
    return IAccountCreationPropertyDtoFromJSONTyped(json, false);
}

export function IAccountCreationPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountCreationPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_creation_type': json['account_creation_type'] == null ? undefined : json['account_creation_type'],
        'account_creation_type_state': json['account_creation_type_state'] == null ? undefined : json['account_creation_type_state'],
    };
}

export function IAccountCreationPropertyDtoToJSON(json: any): IAccountCreationPropertyDto {
    return IAccountCreationPropertyDtoToJSONTyped(json, false);
}

export function IAccountCreationPropertyDtoToJSONTyped(value?: IAccountCreationPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_creation_type': value['account_creation_type'],
        'account_creation_type_state': value['account_creation_type_state'],
    };
}

